<style>
  .Warning {
    background-color: #ff9595 !important;
  }

  .TdTitle {
    background: #17b88b;
    color: white;
    font-weight: bold;
  }

  .AfterTr {
    background-color: #489b39;
    color: white;
  }

  .BeforeTr {
    background-color: #9b3939;
    color: white;
  }
</style>

<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Certificate Information Form</h5>

    <div *ngIf="!Showing_Form_Nominal_Value">


      <app-DataEntityDeviceInfo 
        [inner_calibration_id]="Calibration_Device_Id"
        (outter_Calibration_Device)="Set_CalibrationDeviceInfo_click($event)">
        
      </app-DataEntityDeviceInfo>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Certificate Code </label>
            <input value="{{CertificateCode}}" disabled type="text" class="form-control">
          </div>

          <div class="form-group col-md-4">
              <app-DataEntityLabAddress
              [inner_Calibration_Device_Id]="Calibration_Device_Id"
              [inner_Calibration_Lab_Address]="Calibration_Device.labAdderss"
              (outter_selected_Lab_Address)="Set_LabAddress_click($event)">

            </app-DataEntityLabAddress>
          </div>

          <div class="form-group col-md-4">
            <app-DataEntityLinearity
            [inner_Calibration_Device_Id]="Calibration_Device_Id"
            [inner_Calibration_Display]="Calibration_Device.display_linearity">

          </app-DataEntityLinearity>
        </div>

        </div>
      </form>

      <br />
      <hr />
      <br />

      <app-DataEntityCertificateNote [inner_Calibration_Device_Id]="Calibration_Device_Id">

      </app-DataEntityCertificateNote>

      <br />
      <hr />
      <br />

      <app-AddressLetterCertificate [inner_Calibration_Detail_Id]="Calibration_Device_Id">

      </app-AddressLetterCertificate>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Unit Nominal Value </label>
            <select class="custom-select" (change)="OnUserSetUnit(1,templateUnit)" [(ngModel)]="unit_nomimal" name="unit_nomimal">
              <option value="">Select</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Unit Reference value (Average) </label>
            <select class="custom-select" (change)="OnUserSetUnit(2,templateUnit)" [(ngModel)]="unit_reference" name="unit_reference">
              <option value="">Select</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Unit Correction </label>
            <select class="custom-select" (change)="OnUserSetUnit(3,templateUnit)" [(ngModel)]="unit_correction" name="unit_correction">
              <option value="">Select</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Unit Correction from Line Equation </label>
            <select class="custom-select" (change)="OnUserSetUnit(4,templateUnit)" [(ngModel)]="unit_correction_eqution" name="unit_correction_eqution">
              <option value="">Select</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Unit Uncertainty </label>
            <select class="custom-select" (change)="OnUserSetUnit(5,templateUnit)" [(ngModel)]="unit_uncertainy" name="unit_uncertainy">
              <option value="">Select</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>
          <div class="form-group col-md-4" style="display: none;">
            <label for="exampleInputEmail1"> Unit Correction Factor (Z) </label>
            <select class="custom-select" (change)="OnUserSetUnit(6,templateUnit)" [(ngModel)]="unit_zfactor" name="unit_zfactor">
              <option value="">Select</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />


      <form>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> MANUFACTURE </label>
            <input [(ngModel)]="Manufacture_txt" name="Manufacture_txt" type="text" class="form-control"
              placeholder="Type here...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> TYPE </label>
            <input [(ngModel)]="Type_txt" name="Type_txt" type="text" class="form-control"
              placeholder="Type here...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> MODEL </label>
            <input [(ngModel)]="Model_txt" name="Model_txt" type="text" class="form-control"
              placeholder="Type here...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> DELIVERY TIME (second) </label>
            <input [(ngModel)]="DELIVERY_TIME" name="DELIVERY_TIME" type="number" class="form-control"
              placeholder="Type here...">
          </div>

        </div>
      </form>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Upload File : </label>
            <input type="file" #file_excel>
          </div>
          <div class="form-group col-md-6">
            <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
            <button *ngIf="!Procssing_Import" type="button" class="btn btn-warning"
              (click)="upload_file_excel(file_excel.files)"> Upload File <i class="fa fa-upload"></i></button>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Upload Attachment: </label>
            <input type="file" #file_pdf>
          </div>
          <div class="form-group col-md-6">
            <img *ngIf="Procssing_Import2" src="assets/Loading.gif" style="width: 25px;" />
            <button *ngIf="!Procssing_Import2" type="button" class="btn btn-info"
              (click)="upload_file_pdf(file_pdf.files)"> Upload Attachment <i class="fa fa-upload"></i></button>
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

    </div>



    <div [hidden]="Nominal_Value_List.length==0 || !Showing_Form_Nominal_Value">

      <h4>Edit Nominal Value</h4>
      <br />
      <br />

      <form [formGroup]="MainFormDataEntity">

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Water © before </label>
            <input (keyup)="Calc_Main_Function()" formControlName="Temperature_Water_before" type="number"
              class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_Temperature_Water_before().valid && get_Form_Temperature_Water_before().touched"
              class="form-text text-muted MyErrorRedColor">Enter the water temperature before calibration (°C).</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Water © after </label>
            <input formControlName="Temperature_Water_after" type="number" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_Temperature_Water_after().valid && get_Form_Temperature_Water_after().touched"
              class="form-text text-muted MyErrorRedColor">Enter the water temperature after calibration (°C).</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © before </label>
            <input (keyup)="Calc_Main_Function()" formControlName="Temperature_Air_before" type="number"
              class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_Temperature_Air_before().valid && get_Form_Temperature_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Enter the air temperature before calibration (°C).</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © after </label>
            <input (keyup)="Calc_Main_Function()" formControlName="Temperature_Air_after" type="number"
              class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_Temperature_Air_after().valid && get_Form_Temperature_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Enter the air temperature after calibration (°C).</small>
          </div>
        </div>

        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) before </label>
            <input (keyup)="Calc_Main_Function()" formControlName="Humidity_Air_before" type="number"
              class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_Humidity_Air_before().valid && get_Form_Humidity_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Enter the relative humidity before calibration (%RH).</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) after </label>
            <input formControlName="Humidity_Air_after" type="number" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_Humidity_Air_after().valid && get_Form_Humidity_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Enter the relative humidity after calibration (%RH).</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) before </label>
            <input (keyup)="Calc_Main_Function()" formControlName="Pressure_before" type="number" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_Pressure_before().valid && get_Form_Pressure_before().touched"
              class="form-text text-muted MyErrorRedColor">Enter the ambient pressure before calibration (hPa).</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) after </label>
            <input formControlName="Pressure_after" type="number" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_Pressure_after().valid && get_Form_Pressure_after().touched"
              class="form-text text-muted MyErrorRedColor">Enter the ambient pressure after calibration (hPa).</small>
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-3" [ngClass]="{'Warning': get_Form_Reference_Temperature().value==27 }">
            <label for="exampleInputEmail1"> Reference Temperature </label>
            <select formControlName="Reference_Temperature" class="custom-select">
              <option value="20">20</option>
              <option value="27">27</option>
            </select>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Device </label>
            <input formControlName="Temperature_Device" disabled type="number" class="form-control" value="0">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> &#x3C1;A (g/ml) </label>
            <input formControlName="PA_Device" disabled type="number" class="form-control" value="0">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> &#x3C1;w (g/ml) </label>
            <input formControlName="PW_Device" disabled type="number" class="form-control" value="0">
          </div>

        </div>

        <br />
        <hr />
        <br />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Min Rage </label>
            <input formControlName="range_min" type="text" class="form-control EnglishClm" placeholder="Type here...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Max Rage </label>
            <input formControlName="range_max" type="text" class="form-control EnglishClm" placeholder="Type here...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> SCALE DIVISION </label>
            <input formControlName="scale" type="text" class="form-control EnglishClm" placeholder="Type here...">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Nominal Value (Unit- Volume) </label>
            <input formControlName="Nominal_Value" type="number" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_Nominal_Value().valid && get_Form_Nominal_Value().touched"
              class="form-text text-muted MyErrorRedColor">Enter the nominal value.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> &#x3C1;B (g/ml) </label>
            <input formControlName="y_A" type="number" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_y_A().valid && get_Form_y_A().touched"
              class="form-text text-muted MyErrorRedColor">Enter ρA (g/ml).</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> &#x3B3; </label>
            <input formControlName="y" type="number" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_y().valid && get_Form_y().touched"
              class="form-text text-muted MyErrorRedColor">Enter γ.</small>
          </div>
        </div>
      </form>


      <form [formGroup]="DetailFormDataEntity">
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Mesured Mass (Unit - Mass) </label>
            <input formControlName="Mesured_Mass" (keyup.enter)="Add_Mesured_Mass_List()" type="number"
              class="form-control" placeholder="Type here...">
          </div>

          <div class="form-group col-md-8">
            <button type="button" (click)="Add_Mesured_Mass_List()" class="btn btn-warning" style="margin-right: 5px;"><i
                class="fa  fa-plus-circle"></i> Add Measured Mass </button>

          </div>
        </div>
      </form>

      <div class="table-responsive" *ngIf="Mesured_Mass_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Mesured Mass (Unit - Mass)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Mesured_Mass_List">

              <td>{{Mesured_Mass_List.indexOf(item)+1}}</td>
              <td>
                <input type="text" style="width: 70px;" name="measure_{{Mesured_Mass_List.indexOf(item)}}"
                  [(ngModel)]="item.title">
              </td>

              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" (click)="Delete_Mesured_Mass_List(Mesured_Mass_List.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                    </div>
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>


      <br />
      <hr />
      <br />

    </div>

    <div class="table-responsive" *ngIf="Nominal_Value_List.length>0 && !Showing_Form_Nominal_Value">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">

        <ng-container *ngFor="let item of Nominal_Value_List">

          <tr>
            <td class="TdTitle">Temperature of Water © before</td>
            <td> {{item.temperature_Water_before}} </td>

            <td class="TdTitle">Temperature of Water © after</td>
            <td> {{item.temperature_Water_after}} </td>

            <td class="TdTitle">Temperature of Air © before</td>
            <td> {{item.temperature_Air_before}} </td>

            <td class="TdTitle">Temperature of Air © after</td>
            <td> {{item.temperature_Air_after}} </td>
          </tr>

          <tr>
            <td class="TdTitle">Humidity of Air (%rH) before</td>
            <td> {{item.humidity_Air_before}} </td>

            <td class="TdTitle">Humidity of Air (%rH) after</td>
            <td> {{item.humidity_Air_after}} </td>

            <td class="TdTitle">Ambient Pressure (hPa) before</td>
            <td> {{item.pressure_before}} </td>

            <td class="TdTitle">Ambient Pressure (hPa) after</td>
            <td> {{item.pressure_after}} </td>

          </tr>

          <tr>
            <td class="TdTitle">Reference Temperature</td>
            <td> {{item.reference_Temperature}} </td>

            <td class="TdTitle">Temperature of Device</td>
            <td> {{item.Temperature_Device}} </td>

            <td class="TdTitle">&#x3C1;A (g/ml)</td>
            <td> {{item.PA}} </td>

            <td class="TdTitle">&#x3C1;w (g/ml)</td>
            <td> {{item.PW}} </td>
          </tr>

          <tr>
            <td colspan="8">

              <table class="mb-0 table table-bordered table-3 text-center table-striped">

                <thead [ngClass]="{'BeforeTr': item.before==true,'AfterTr': item.before==false }">
                  <tr>
                    <th>#</th>
                    <th>Nominal Value (Unit- Volume)</th>
                    <th>Average</th>
                    <!--
                  <th>SD</th>
                  <th>CV</th>
                  <th>&#x3C1;B (g/ml)</th>
                  <th>&#x3B3; (g/ml)</th>
                  <th>Reference Value (Unit- Volume)</th>
                  <th>Value</th>
                -->
                    <th>Converge Factor</th>
                    <th>Z Factor</th>
                    <th>uncertainty</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <ng-container>

                    <tr [ngClass]="{'Warning': item.error>MPE_RND && item.sd>item.mpe_rnd }">

                      <td>{{Nominal_Value_List.indexOf(item)+1}}</td>
                      <td>{{item.nominal}}</td>
                      <td>{{item.average}}</td>
                      <!--
                    <td>{{item.sd}}</td>
                    <td>{{item.cv}}</td>
                    <td>{{item.yb}}</td>
                    <td>{{item.y}}</td>
                    <td>{{item.reference_Value}}</td>
                    <td>{{item.value}}</td>
                  -->
                      <td>{{item.converage}}</td>
                      <td>{{item.zFactor}}</td>
                      <td> {{item.uncertainty}} </td>
                      <td>
                        <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                          <div class="btn-group" role="group">
                            <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Actions
                            </button>
                            <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                              <a style="cursor: pointer;"
                                (click)="Edit_Nominal_Value_List(Nominal_Value_List.indexOf(item))"
                                class="dropdown-item"><i class="fa fa-edit"></i> Edit </a>

                              <a style="cursor: pointer;"
                                *ngIf="Nominal_Value_List.indexOf(item)==0 && item.before==false"
                                (click)="Copy_After_As_Before()" class="dropdown-item"><i
                                  class="fa fa-arrow-circle-down"></i> Copy to Before </a>

                              <a style="cursor: pointer;" *ngIf="!item.mesured_visible"
                                (click)="Visible_Nominal_Value_List(Nominal_Value_List.indexOf(item))"
                                class="dropdown-item"><i class="fa fa-eye"></i> View Details </a>
                              <a style="cursor: pointer;" *ngIf="item.mesured_visible"
                                (click)="Visible_Nominal_Value_List(Nominal_Value_List.indexOf(item))"
                                class="dropdown-item"><i class="fa fa-eye-slash"></i> Hide Details </a>

                              <a style="cursor: pointer;" *ngIf="Nominal_Value_List.indexOf(item)>0"
                                (click)="Copy_From_Up(Nominal_Value_List.indexOf(item))" class="dropdown-item"><i
                                  class="fa fa-arrow-circle-up"></i> Copy Environment from Above </a>

                              <a style="cursor: pointer;"
                                *ngIf="Nominal_Value_List.indexOf(item)<(Nominal_Value_List.length-1)"
                                (click)="Copy_From_Down(Nominal_Value_List.indexOf(item))" class="dropdown-item"><i
                                  class="fa fa-arrow-circle-down"></i> Copy Environment from Below </a>

                            </div>
                          </div>
                        </div>
                      </td>

                    </tr>

                    <tr *ngIf="item.mesured_visible">
                      <td colspan="8">
                        <table class="mb-0 table table-bordered table-3 text-center table-striped">
                          <thead style="background-color: #39649b; color: white;">
                            <tr>
                              <th>#</th>
                              <th>Mesured Mass (Unit - Mass)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let itemdetail of item.mesured; let j = index">
                              <td>{{j+1}}</td>
                              <td>{{itemdetail}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                  </ng-container>
                </tbody>

              </table>

            </td>
          </tr>

        </ng-container>

      </table>
    </div>

    <div *ngIf="Showing_Form_Nominal_Value">
      <div class="row">
        <div class="form-group col-md-8">
          <button type="button" [disabled]="!MainFormDataEntity.valid" (click)="Add_Nominal_Value(templateAfter,0)"
            class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Edit Nominal
            Value</button>

          <button *ngIf="!InProccessing" (click)="Cancel_Nominal_Value_List()" type="button" class="btn btn-danger"
            style="margin-right: 5px;"><i class="fa fa-times-rectangle"></i> Cancel </button>
        </div>
      </div>
    </div>

    <div *ngIf="!Showing_Form_Nominal_Value">

      <br />
      <hr />
      <br />
      <button *ngIf="InProccessing" type="button" class="btn btn-info" style="margin-right: 5px;"> This feature is under development.
        The certificate is being generated. Please wait... <i class="fa fa-spin fa-spinner"></i> </button>

      <button *ngIf="!InProccessing && !CertificateCode" type="button"
        (click)="onSubmit(templateCode)" class="btn btn-success" style="margin-right: 5px;"><i
          class="fa  fa-plus-circle"></i> Save Certificate Information </button>
      <button *ngIf="!InProccessing && CertificateCode" type="button"
        (click)="onSubmit(templateCode)" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-edit"></i>
        Edit
        Certificate Information </button>

      <a target="_blank" *ngIf="!InProccessing && CertificateCode && CertificateUrlPdf"
        href="{{CertificateUrlPdf}}" style="margin-right: 5px;" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> Calibration Certificate File </a>

      <button routerLink="/KartableInbox" *ngIf="!InProccessing" type="button"
        style="margin-right: 5px;" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>



    </div>

  </div>
</div>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Certificate Code </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Calibration form certificate code <b>'{{CertificateCode}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateAfter>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Warning </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_After.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <h6> The nominal value is outside the range. </h6>
    <h6> Do you want to approve the nominal value? </h6>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="Confirm_Nominal_Value(1)">Yes, Approve</button>
    <button type="button" class="btn btn-danger" (click)="Confirm_Nominal_Value(0)">No</button>
  </div>
</ng-template>

<ng-template #templateUnit>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> Apply the selected unit to unspecified units? </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Unit.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="SetToAllUnit()"> Yes, Apply <i class="fa fa-check"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Unit.hide()">Close</button>
  </div>
</ng-template>
